import { useAuth } from "@/context/AuthContext";

export const AuthShell = ({ title, desc, children }) => {
  const { ayar } = useAuth();
  return (
    <div className="min-h-screen app-bg grid lg:grid-cols-[1.1fr_1fr]">
      <div className="hidden lg:flex flex-col justify-between p-14 relative overflow-hidden">
        <div className="flex items-center gap-3">
          <img src={"/icon-192.png"} alt="logo" data-testid="auth-brand-logo" className="w-11 h-11 rounded-full object-cover glow" />
          <span className="font-head font-semibold text-lg" data-testid="auth-brand-name">{ayar?.kisa_ad || ayar?.unvan || "Dinamik Performans"}</span>
        </div>
        <div className="max-w-lg">
          <div className="text-[11px] tracking-[0.3em] uppercase text-muted-foreground mb-5">Sipariş → Üretim → Depo → Sevkiyat → Finans</div>
          <h1 className="font-head text-5xl xl:text-6xl font-bold leading-[1.05]">
            Fabrikanın tamamı <span className="grad-text">tek ekranda.</span>
          </h1>
          <p className="text-muted-foreground mt-6 leading-relaxed">
            Maliyet, termin, istasyon devri, depo ve kargo — her adım kayıt altında, her sektöre uyarlanabilir.
          </p>
        </div>
        <div className="flex gap-8 text-xs text-muted-foreground">
          {["Çok lokasyon", "İstasyon bazlı üretim", "Reçete & COGS"].map((x) => (
            <div key={x} className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full grad-bg" />{x}</div>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <div className="glass rounded-3xl w-full max-w-md p-8 sm:p-10 fade-up">
          <div className="lg:hidden flex items-center gap-3 mb-6">
            <img src={"/icon-192.png"} alt="logo" className="w-10 h-10 rounded-full object-cover" />
            <span className="font-head font-semibold">{ayar?.kisa_ad || ayar?.unvan || "Dinamik Performans"}</span>
          </div>
          <h2 className="font-head text-2xl font-bold">{title}</h2>
          {desc && <p className="text-sm text-muted-foreground mt-1.5 mb-7">{desc}</p>}
          {children}
        </div>
      </div>
    </div>
  );
};
